import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import { NavLink } from "react-router-dom";
import YasuLogo from "../../../assets/images/yasu-logo.png";
import "./Navbar.scss";
import MobileNavbar from "./MobileNavbar/MobileNavbar";
import { navItems } from "./navItems";
import { GenericProps } from "../../../types/types";
import { FC, Fragment } from "react";
import { Link } from "@mui/material";

const Navbar: FC<GenericProps> = ({ className = "" }) => {
  return (
    <AppBar className={`NavbarCustom absolute top-0 left-0 w-full bg-transparent shadow-none z-50 py-4 ${className}`}>
      <Container>
        <Toolbar className="flex items-center justify-between max-md:px-0">
          {/* only show on small screen sizes */}
          <MobileNavbar className="md:hidden" />

          <div className="flex items-center">
            <NavLink to="/explore-world" className="max-md:hidden flex items-center no-underline">
              <img src={YasuLogo} alt="Yasu logo" width={70} height={70} />
            </NavLink>
          </div>

          {/* only show on medium+ screen sizes */}
          <div className="max-md:hidden flex-grow flex items-center justify-center">
            {navItems.common.map((item) => (
              <Fragment key={item.label}>
                {item.external ? (
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    href={item.path}
                    className={`text-white no-underline text-lg mx-4`}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `text-white text-lg mx-4 ${isActive ? "underline decoration-2 underline-offset-4" : "no-underline"}`
                    }
                  >
                    {item.label}
                  </NavLink>
                )}
              </Fragment>
            ))}
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
